import React from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import Container from "../styles/Container";
import { theme } from "../styles/theme";

const BrandSection = styled.section`
  text-align: center;
  margin: 10em 0;

  h1 {
    font-size: 6rem;
  }
`;
const BrandGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr
  padding: 2rem 0;
  gap: 1em;

  @media ${theme.devices.md} {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 1fr;
    gap: 3rem;
  }

  margin: 4rem 0;
`;

const Brand = styled.div`
  border: 3px solid var(--grey);

  border-radius: 0.7rem;
  .brand {
    margin: 3rem 0rem;
  }
`;

export default function Brands() {
  return (
    <BrandSection>
      <Container>
        <h1>we've covered every brand</h1>
        <BrandGrid>
          <Brand>
            <StaticImage src="../assets/images/client1.png" className="brand" />
          </Brand>
          <Brand>
            <StaticImage src="../assets/images/client2.png" className="brand" />
          </Brand>
          <Brand>
            <StaticImage src="../assets/images/client3.png" className="brand" />
          </Brand>
          <Brand>
            <StaticImage src="../assets/images/client4.png" className="brand" />
          </Brand>
          <Brand>
            <StaticImage src="../assets/images/client5.png" className="brand" />
          </Brand>

          <Brand>
            <StaticImage src="../assets/images/client6.png" className="brand" />
          </Brand>
        </BrandGrid>
      </Container>
    </BrandSection>
  );
}
